import React, { useEffect, useState } from 'react'
import {
  makeStyles,
  createStyles,
  Box,
  Button,
  Typography,
  Divider,
  useMediaQuery,
  useTheme,
} from '@material-ui/core'
import getTime from 'date-fns/getTime'
import isBefore from 'date-fns/isBefore'
import parse from 'date-fns/parse'
import { useParams, useHistory, useRouteMatch } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import Countdown from 'react-countdown'
import { useTranslation } from 'react-i18next'
import ENumberFormat from 'src/mobile/themes/components/ENumberFormat'
import { pay, getOrderInfo, applyRefund, cancelRefund } from 'src/store/slices/userSlice'
import { useDateFnsLocale, useCustomTranslation, useAddressFormat } from 'src/hooks'
import { getDoctorList } from 'src/store/slices/testCenterSlice'
import { getUserInfo } from 'src/store/slices/authSlice'
import { ReactComponent as PendingPayment } from 'src/mobile/assets/icons/pending_payment.svg'
import { ReactComponent as Refund } from 'src/mobile/assets/icons/refunded.svg'
import { ReactComponent as FailRefund } from 'src/mobile/assets/icons/failed_refunded.svg'
import { ReactComponent as Refunding } from 'src/mobile/assets/icons/refunding.svg'
import { ReactComponent as Paid } from 'src/mobile/assets/icons/paid.svg'
import { ReactComponent as Return } from '../../../assets/icons/Return.svg'
import EDrawer from 'src/mobile/themes/components/EDrawer'
import PersonOutlineOutlinedIcon from '@material-ui/icons/PersonOutlineOutlined'
import {
  PAY_EXPIRED_TIME,
  SERVICE_PHONE_02,
  SERVICE_CHARGE_RATE,
  DATE_FORMAT,
  DATABASE_DATE_TIMEZONE_TIME_FORMAT,
  TIMEZONE,
  ORDER_STATUS,
  PACKAGE_INFO,
  SITE_MATE_DATA,
} from 'src/utils/constant'
import { encryptPhone, encryptEmail, encryptId, formatDialingCode, translateRegion } from 'src/utils'
import Loading from 'src/mobile/components/Loading'
// import TagManager from 'react-gtm-module'
import InfoWrapper from 'src/mobile/components/InfoWrapper'
import InfoItem from 'src/mobile/components/Order/InfoItem'
import FixedButtonWrapper from 'src/mobile/components/FixedButtonWrapper'
// import DotsBackground from 'src/mobile/components/DotsBackground'
import { ORDER_STATUS_HEADER } from 'src/mobile/utils/constant'
import EDialog from 'src/mobile/themes/components/EDialog'
import OrderDialogContent from '../../components/Order/OrderDialogContent'
import { ReactComponent as Success } from '../../../assets/icons/success.svg'
import LocationOnOutlinedIcon from '@material-ui/icons/LocationOnOutlined'
// import CallOutlinedIcon from '@material-ui/icons/CallOutlined'
import DateRangeOutlinedIcon from '@material-ui/icons/DateRangeOutlined'
import AccessTimeIcon from '@material-ui/icons/AccessTime'
import { ReactComponent as DoctorIcon } from 'src/mobile/assets/icons/doctor2.svg'
import translationHK from 'src/assets/locales/zh-HK/translation.json'
import { purchase, buttonClick } from 'src/utils/trackingCode'
import GoogleMap from '../../../mobile/components/GoogleMap'
import MapOutlinedIcon from '@material-ui/icons/MapOutlined'

const useStyles = makeStyles((theme) =>
  createStyles({
    link: {
      color: theme.palette.secondary.main,
    },
    icon: {
      '& svg': {
        width: '100%',
        height: '100%',
        '& path': {
          fill: theme.palette.secondary.contrastText,
        },
      },
    },
    label: {
      color: theme.palette.grey[400],
      fontSize: theme.typography.body2.fontSize,
    },
    itemValue: {
      fontWeight: theme.typography.fontWeightMedium,
      fontSize: theme.typography.body1.fontSize,
      color: theme.palette.grey[800],
    },
    paperAnchorBottom: {
      maxHeight: '90%',
      padding: theme.spacing(0),
    },
    formLabel: {
      display: 'flex',
      color: theme.palette.text.primary,
      fontSize: 18,
      fontWeight: 500,
      lineHeight: '26px',
    },
    form: {
      height: '800px !important',
    },
    formRefund: {
      height: '500px !important',
    },
    titleTop: {
      height: '70px !important',
    },
    radio: {
      display: 'flex',
      flexDirection: 'column',
      marginLeft: theme.spacing(2),
      color: theme.palette.text.primary,
    },
    labelText: {
      fontSize: 18,
    },
    heading: {
      fontSize: 16,
      fontWeight: 400,
      [theme.breakpoints.down('xs')]: {
        fontSize: 14,
      },
    },
    secondaryHeading: {
      fontSize: 16,
      fontWeight: 500,
      color: theme.palette.text.secondary,
      marginLeft: theme.spacing(18),
      [theme.breakpoints.down('xs')]: {
        fontSize: 14,
      },
    },
    accord: {
      boxShadow: 'none',
    },
    accordion: {
      padding: 0,
    },
    accordionDetails: {
      display: 'flex',
      alignItems: 'center',
      padding: 0,
      justifyContent: 'space-between',
    },
    border: {
      border: '1px solid #E5E7EB',
      borderRadius: '24px',
      padding: theme.spacing(3),
      [theme.breakpoints.down('xs')]: {
        border: 'none',
        padding: 0,
      },
    },
  }),
)

const ItemDot = () => (
  <Box color="grey.900" mr={1} component="span">
    •
  </Box>
)

const OrderInfo = ({ step }) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const history = useHistory()
  const { t, i18n } = useTranslation()
  const [tB] = useCustomTranslation()
  const { formatDate } = useDateFnsLocale()
  const { orderInfo, orderInfoStatus } = useSelector((state) => state.user)
  const { userInfo } = useSelector((state) => state.auth)
  const { orderNumber } = useParams()
  const [drawerOpen, setEDrawerOpen] = useState(false)
  const theme = useTheme()
  const { addressFormat } = useAddressFormat()

  const matches = useMediaQuery(theme.breakpoints.down('xs'))
  const isPayingSuccessPage = useRouteMatch(`/${i18n.language}/add-order/success/:orderNumber`)
  const setOrderInfo = async () => await dispatch(getOrderInfo({ orderNumber: orderNumber })).unwrap()
  const { allDoctorList } = useSelector((state) => state.testCenter)
  useEffect(() => {
    !allDoctorList?.length && dispatch(getDoctorList())
  }, [])

  useEffect(() => {
    setOrderInfo()
  }, [])
  useEffect(() => {
    dispatch(getUserInfo())
  }, [])

  useEffect(async () => {
    if (!orderInfo) return
    // Step 1 only show PENDING_PAYMENT status order and Step 2  only show PAID, or replace with order detail page.
    if (
      step &&
      !(
        (step === 1 && orderInfo?.payStatus === ORDER_STATUS.PENDING_PAYMENT) ||
        (step === 2 &&
          orderInfo?.payStatus === ORDER_STATUS.PAID &&
          isBefore(new Date(), parse(orderInfo?.appointmentDate, DATE_FORMAT, new Date())))
      )
    ) {
      history.replace(`/profile/order/${orderNumber}`)
    }

    if (isPayingSuccessPage && orderInfo?.payStatus === ORDER_STATUS.PAID) {
      // TagManager.dataLayer({
      //   dataLayer: {
      //     ecommerce: null,
      //   },
      // })
      // TagManager.dataLayer({
      //   dataLayer: {
      //     event: 'purchase',
      //     ecommerce: {
      //       purchase: {
      //         actionField: {
      //           id: `${orderInfo.orderNumber || ''}`,
      //           revenue: `${orderInfo.price || ''}`,
      //           tax: '0',
      //           shipping: '0',
      //           coupon: orderInfo.promotionCode || '',
      //         },
      //         products: [
      //           {
      //             name: orderInfo.doctorName || '',
      //             id: `${orderInfo.doctorId || ''}`,
      //             price: `${orderInfo.price || ''}`,
      //             brand: orderInfo.testCenterName || '',
      //             category: orderInfo.doctorTitle || '',
      //             variant: orderInfo.appointmentTime || '',
      //             dimension1: orderInfo.appointmentDate || '',
      //             quantity: 1,
      //           },
      //         ],
      //       },
      //     },
      //   },
      // })
    }
  }, [orderInfo])

  const handlePay = async () => {
    if (orderInfo.currency !== 'HKD') {
      // TagManager.dataLayer({
      //   dataLayer: {
      //     ecommerce: null,
      //   },
      // })
      // TagManager.dataLayer({
      //   dataLayer: {
      //     event: 'checkout',
      //     ecommerce: {
      //       checkout: {
      //         actionField: { step: 2 },
      //         products: [
      //           {
      //             name: orderInfo.doctorName || '',
      //             id: `${orderInfo.doctorId || ''}`,
      //             price: `${orderInfo.price || ''}`,
      //             brand: orderInfo.testCenterName || '',
      //             category: orderInfo.doctorTitle || '',
      //             variant: orderInfo.appointmentTime || '',
      //             dimension1: orderInfo.appointmentDate || '',
      //             quantity: 1,
      //           },
      //         ],
      //       },
      //     },
      //   },
      // })
      await dispatch(pay({ orderNumber: orderNumber }))
    } else {
      history.replace(`/${i18n.language}/add-order/paying`, {
        price: orderInfo.price,
        currency: orderInfo.currency,
        orderNumber: orderNumber,
        packages: orderInfo.package,
        from: 'orderInfo',
      })
    }
  }

  const handleRefund = async () => {
    await dispatch(applyRefund({ orderNumber: orderNumber })).unwrap()
    setOrderInfo()
  }

  const handleCancelRefund = async () => {
    await dispatch(cancelRefund({ orderNumber: orderNumber })).unwrap()
    setOrderInfo()
    setEDrawerOpen(false)
  }

  const statusMark = (status) => {
    return (
      <Box
        alignItems="center"
        display="flex"
        fontSize={16}
        color={
          status === ORDER_STATUS.PENDING_REFUND || status === ORDER_STATUS.APPROVAL_SUCCEED
            ? 'secondary.main'
            : status === ORDER_STATUS.PAID
            ? '#0CB458'
            : status === ORDER_STATUS.PENDING_PAYMENT
            ? '#CC9809'
            : 'grey.800'
        }
      >
        {t(ORDER_STATUS_HEADER?.[status]?.label)}
      </Box>
    )
  }

  const addTrackingCode = () => {
    const title = PACKAGE_INFO[Number(orderInfo?.package)].title
    const titleArr = title.split('.')
    const len = titleArr.length - 1
    let name
    let num = 0
    let obj = translationHK
    while (num <= len) {
      name = obj[titleArr[num]]
      obj = obj[titleArr[num]]
      num++
    }
    const ecommerce = {
      currency: orderInfo?.currency,
      value: orderInfo?.payPrice,
      transaction_id: orderInfo.paymentNumber,
      coupon: orderInfo.promotionCode,
      items: [
        {
          item_id: PACKAGE_INFO[Number(orderInfo?.package)].id,
          item_name: name,
          index: PACKAGE_INFO[Number(orderInfo?.package)].index,
          price: orderInfo?.price,
          item_category: orderInfo.testCenterNameHk,
          item_category2: orderInfo.appointmentDate,
          item_category3: orderInfo.appointmentTime,
          item_category4: orderInfo.doctorNameHk,
          item_category5: 'No',
        },
      ],
    }
    purchase(ecommerce)
  }

  useEffect(() => {
    if (orderInfo?.payStatus === 1 && isPayingSuccessPage) {
      addTrackingCode()
    }
  }, [orderInfo?.payStatus])

  const fixedButtonWrapper = (status) => {
    return (
      <>
        {status === ORDER_STATUS.PENDING_PAYMENT && (
          <FixedButtonWrapper>
            <Box my={1}>
              {' '}
              <Box mt={0.5} alignItems="center" display="flex">
                <Button variant="contained" color="secondary" fullWidth onClick={handlePay}>
                  {t('glossary.go_to_pay')}
                </Button>
              </Box>
            </Box>
          </FixedButtonWrapper>
        )}
        {(status === ORDER_STATUS.PENDING_REFUND || status === ORDER_STATUS.APPROVAL_SUCCEED) && (
          <FixedButtonWrapper>
            <Box my={1}>
              <Box ml="auto">
                <EDialog
                  loading
                  title={t('are_you_sure.common', { action: '$t(glossary.cancel_refund)' })}
                  trigger={
                    <Button fullWidth variant="contained" color="secondary">
                      {t('glossary.cancel_refund')}
                    </Button>
                  }
                  onConfirm={handleCancelRefund}
                />
              </Box>
            </Box>
          </FixedButtonWrapper>
        )}
        {status === ORDER_STATUS.PAID && !isPayingSuccessPage && (
          <FixedButtonWrapper>
            <Box my={1}>
              <Box display="flex" justifyContent="space-between">
                <Box
                  width={
                    isBefore(new Date(), parse(orderInfo?.appointmentDate, DATE_FORMAT, new Date()))
                      ? '48%'
                      : '100%'
                  }
                >
                  <EDialog
                    loading
                    updateBooking={true}
                    title={t('common.update_booking')}
                    trigger={
                      <Button fullWidth variant="outlined">
                        {t('common.update_booking')}
                      </Button>
                    }
                    onConfirm={() => {
                      window.location.href =
                        i18n.language === 'zh-HK'
                          ? SITE_MATE_DATA.WHATSAPP_UPDATE_HK
                          : i18n.language === 'en'
                          ? SITE_MATE_DATA.WHATSAPP_UPDATE_EN
                          : SITE_MATE_DATA.WHATSAPP_UPDATE_CN
                    }}
                  >
                    <Box my={2}> {t('common.update_booking_tips', { field: SERVICE_PHONE_02 })}</Box>
                  </EDialog>
                </Box>{' '}
                {isBefore(new Date(), parse(orderInfo?.appointmentDate, DATE_FORMAT, new Date())) && (
                  <Box width="48%">
                    <Button
                      fullWidth
                      style={{ background: '#D6334D', color: '#fff' }}
                      onClick={() => setEDrawerOpen(true)}
                      // variant="outlined"
                    >
                      {t('glossary.apply_refund')}
                    </Button>

                    <EDrawer
                      onClose={() => setEDrawerOpen(false)}
                      open={drawerOpen}
                      title={t('glossary.apply_refund')}
                    >
                      <Divider />
                      <Box color="grey.900" my={2} lineHeight={1.5}>
                        {t('common.refund_tips')}
                      </Box>
                      <Divider />
                      <Box fontSize={16} fontWeight={600} lineHeight={2}>
                        {t('glossary.pay_amount')}
                      </Box>{' '}
                      <ENumberFormat
                        color="grey.400"
                        value={orderInfo?.payPrice}
                        currency={orderInfo?.currency}
                      />
                      <Box fontSize={16} fontWeight={600} lineHeight={2} mt={1.5}>
                        {t('glossary.refund_amount')}
                      </Box>
                      <ENumberFormat
                        // type="simple"
                        color="grey.400"
                        value={
                          orderInfo.payMethod === 'Atome'
                            ? orderInfo.payPrice
                            : orderInfo?.payPrice *
                              (1 -
                                (orderInfo?.refundOrigin || orderInfo.payStatus === 1
                                  ? SERVICE_CHARGE_RATE
                                  : 0))
                        }
                        currency={orderInfo?.currency}
                      />
                      <Divider style={{ marginTop: '16px' }} />
                      <Box display="flex" my={1} justifyContent="space-between">
                        <Box className={classes.column} flexShrink="0">
                          <Typography className={classes.heading}>{t('glossary.order_id')}</Typography>
                        </Box>
                        <Box>
                          <Typography className={classes.secondaryHeading}>
                            {orderInfo?.orderNumber}
                          </Typography>
                        </Box>
                      </Box>
                      <Divider />
                      <Box mt={2}>
                        <Box fontSize={18} fontWeight={700}>
                          {t(PACKAGE_INFO[orderInfo?.package].title)}
                        </Box>
                      </Box>
                      <Box display="flex" alignItems="center" my={1}>
                        <LocationOnOutlinedIcon variant="outline" style={{ fontSize: 16, marginRight: 4 }} />
                        <Box component="span" fontSize={16} fontWeight={700}>
                          {orderInfo?.[tB('testCenterName')]}
                        </Box>
                      </Box>{' '}
                      <Box fontSize={14} ml={2.5} mb={2} color="#4B5563">
                        {orderInfo?.[tB('testCenterAddress')]}
                      </Box>
                      <Divider />
                      <Box display="flex" alignItems="center" my={2} justifyContent="space-between">
                        <Box display="flex" alignItems="center" fontWeight={600} fontSize={14}>
                          <DateRangeOutlinedIcon variant="outline" style={{ marginRight: 4 }} />
                          {t('common.booking_date')}
                        </Box>
                        <Box component="span" fontSize={14}>
                          {formatDate(new Date(orderInfo?.appointmentDate))}
                        </Box>
                      </Box>
                      <Divider />
                      <Box
                        component="span"
                        display="flex"
                        alignItems="center"
                        my={2}
                        justifyContent="space-between"
                      >
                        <Box display="flex" alignItems="center" fontWeight={600} fontSize={14}>
                          <AccessTimeIcon variant="outline" style={{ marginRight: 4 }} />
                          {t('glossary.appointment_time')}
                        </Box>
                        <Box fontSize={14}> {orderInfo?.appointmentTime}</Box>
                      </Box>
                      <Divider />
                      <Box display="flex" alignItems="center" my={2} justifyContent="space-between">
                        <Box display="flex" alignItems="center" fontWeight={600} fontSize={14}>
                          <DoctorIcon variant="outline" style={{ marginRight: 4 }} />
                          {t('glossary.doctor')}
                        </Box>
                        <Box component="span" fontSize={14} fontWeight={700}>
                          {orderInfo?.[tB('doctorName')] || ''}
                        </Box>
                      </Box>
                      <Divider />
                      <Box display="flex" alignItems="center" my={2} justifyContent="space-between" pb={1}>
                        <Box display="flex" alignItems="center" fontWeight={600} fontSize={14}>
                          <PersonOutlineOutlinedIcon variant="outline" style={{ marginRight: 4 }} />
                          {t('common.tester')}
                        </Box>
                        <Box component="span" fontSize={14}>
                          {orderInfo?.userName}
                        </Box>{' '}
                      </Box>{' '}
                      <Box display="flex">
                        {' '}
                        <EDialog
                          loading
                          noAction={true}
                          title={t('common.refund_rules')}
                          trigger={
                            <Box mb={2} style={{ textDecorationLine: 'underline' }}>
                              {t('common.refund_notice')}
                            </Box>
                          }
                        >
                          <Box my={1} lineHeight={1.5} fontSize={16}>
                            {' '}
                            {t('common.refund_detail_rules')}
                          </Box>
                        </EDialog>
                      </Box>
                      <Button
                        onClick={() => {
                          buttonClick(
                            'EH_MyAccount_Refund_ConfirmRefund',
                            'EH_MyAccount_Refund_ConfirmRefund',
                          )
                          handleRefund()
                        }}
                        style={{ background: '#D6334D', color: '#fff' }}
                      >
                        {t('common.confirm_refund')}
                      </Button>
                      <Button
                        onClick={() => setEDrawerOpen(false)}
                        variant="outlined"
                        style={{ marginTop: '8px' }}
                      >
                        {t('common.cancel')}
                      </Button>
                    </EDrawer>
                  </Box>
                )}
              </Box>
            </Box>
          </FixedButtonWrapper>
        )}
        {step === 1 && status === ORDER_STATUS.PENDING_PAYMENT && (
          <FixedButtonWrapper>
            <Box width="100%" display="flex" mt={0.5}>
              <Box mr={1} width="100%">
                <EDialog
                  loading
                  trigger={
                    <Button fullWidth size="small" variant="contained" color="secondary">
                      <ENumberFormat
                        type="simple"
                        value={orderInfo?.price}
                        currency={orderInfo?.currency}
                        noCurrency
                      />
                      <Box flexShrink={0} ml={0.5} component="span">
                        {t('glossary.go_to_pay')}
                      </Box>
                    </Button>
                  }
                  onConfirm={handlePay}
                >
                  <OrderDialogContent orderInfo={orderInfo} />
                </EDialog>
              </Box>
              <Box flexShrink={0} onClick={() => history.push(`/${i18n.language}/profile/order`)}>
                <Button size="small" variant="outlined" color="primary">
                  {t('glossary.view_order_list')}
                </Button>
              </Box>
            </Box>
          </FixedButtonWrapper>
        )}
        {step === 2 &&
          status === ORDER_STATUS.PAID &&
          isBefore(new Date(), parse(orderInfo?.appointmentDate, DATE_FORMAT, new Date())) && (
            <FixedButtonWrapper>
              <Box width="100%" display="flex" mt={0.5}>
                {/* <EDialog
                  loading
                  title={t('are_you_sure.common', {
                    action: '$t(common.apply)',
                    field: '$t(common.refund)',
                  })}
                  trigger={
                    <Button size="small" variant="outlined" color="primary">
                      {t('glossary.apply_refund')}
                    </Button>
                  }
                  onConfirm={handleRefund}
                >
                  <OrderDialogContent orderInfo={orderInfo} />
                </EDialog> */}
                <Box width="100%" onClick={() => history.push(`/${i18n.language}/profile/order`)}>
                  <Button fullWidth size="small" variant="contained" color="secondary">
                    {t('glossary.view_order_list')}
                  </Button>
                </Box>
              </Box>
            </FixedButtonWrapper>
          )}
      </>
    )
  }

  return orderInfo && orderInfoStatus !== 'pending' ? (
    <>
      {/* {!step && <DotsBackground bgColor={ORDER_STATUS_HEADER?.[orderInfo?.payStatus]?.bgColor} />} */}
      {(orderInfo?.payStatus === ORDER_STATUS.PENDING_REFUND ||
        orderInfo?.payStatus === ORDER_STATUS.APPROVAL_SUCCEED) && (
        <Box fontSize={16} p={2} bgcolor="#1F2937" color="#ffff" lineHeight={1.5}>
          {orderInfo?.payStatus === ORDER_STATUS.PENDING_REFUND && <Box>{t('tips.refund_tips_list.1')}</Box>}
          <Box>
            {t('common.apple_refund_time')}:{orderInfo?.refundApplyTime?.slice(0, 11)}
          </Box>
        </Box>
      )}
      {(orderInfo?.payStatus === ORDER_STATUS.REFUND_FAILED ||
        orderInfo?.payStatus === ORDER_STATUS.APPROVAL_FAILED) && (
        <Box fontSize={16} p={2} bgcolor="#1F2937" color="#ffff" lineHeight={1.5}>
          <Box>{t('tips.refund_failed')}</Box>
          <Box>
            {t('common.apple_refund_time')}:{orderInfo?.refundApplyTime?.slice(0, 11)}
          </Box>
        </Box>
      )}
      {orderInfo?.payStatus === ORDER_STATUS.REFUNDED && (
        <Box fontSize={16} p={2} bgcolor="#1F2937" color="#ffff" lineHeight={1.5}>
          <Box>{t('tip.refunded', { field: SERVICE_PHONE_02 })}</Box>
          <Box>
            {t('common.apple_refund_time')}:{orderInfo?.refundApplyTime?.slice(0, 11)}
          </Box>
        </Box>
      )}
      {orderInfo?.payStatus === ORDER_STATUS.PENDING_PAYMENT && (
        <Box fontSize={16} p={2} bgcolor="#FFBE0B" color="#ffff" lineHeight={1.5}>
          <Typography variant="body2" noWrap component="div">
            <Countdown
              date={
                getTime(
                  parse(orderInfo?.createTime + TIMEZONE, DATABASE_DATE_TIMEZONE_TIME_FORMAT, new Date()),
                ) + PAY_EXPIRED_TIME
              }
              onComplete={setOrderInfo}
              autoStart
              renderer={({ hours, minutes, seconds, completed }) => {
                if (completed) {
                  return (
                    <Box color="grey.900" component="span" fontSize={16} lineHeight={2}>
                      {t('tips.order_time_out')}
                    </Box>
                  )
                } else {
                  // Render a countdown
                  return (
                    <Box color="grey.900" component="span" fontSize={16} lineHeight={1.5}>
                      <Box>{t('common.tip_pay')}</Box>
                      <Box>{t('glossary.time_left_to_pay')}</Box>
                      <Box component="span" fontWeight={600}>
                        {`0${hours}`.slice(-2)}:{`0${minutes}`.slice(-2)}:{`0${seconds}`.slice(-2)}{' '}
                      </Box>
                    </Box>
                  )
                }
              }}
            />
          </Typography>
        </Box>
      )}
      {fixedButtonWrapper(orderInfo?.payStatus)}
      <Box position="relative">
        {orderInfo?.payStatus === 1 && isPayingSuccessPage && (
          <Box
            display="flex"
            alignItems="center"
            flexDirection="column"
            justifyContent="center"
            minHeight={300}
            bgcolor="#fff"
          >
            <Success />
            <Box my={2} fontWeight={600} fontSize={matches ? 26 : 32} textAlign="center">
              {t('glossary.appointment_process_list.4')}
            </Box>
            <Button
              color="secondary"
              variant="contained"
              style={{
                width: matches ? '300px' : '183px',
                height: '56px',
                fontSize: '16px',
              }}
              onClick={() => {
                if (matches) {
                  history.push(`/${i18n.language}/profile/order`)
                } else {
                  history.push(`/${i18n.language}/profile/order`)
                }
              }}
            >
              {t('coomon.back_my_bookig')}
            </Button>
          </Box>
        )}

        <InfoWrapper margin="none">
          <Box className={classes.border}>
            {!isPayingSuccessPage && (
              <Box
                mt={1}
                color="primary.main"
                fontSize={14}
                fontWeight={700}
                border="1px solid #E5E7EB"
                display="flex"
                width={80}
                height={30}
                borderRadius={30}
                alignItems="center"
                justifyContent="center"
                className={classes.back}
                onClick={() => history.push(`/${i18n.language}/profile/order`)}
              >
                <Return />
                {t('common.back')}
              </Box>
            )}
            <Box display="flex" justifyContent="space-between" my={1}>
              <Box fontSize={matches ? 18 : 20} fontWeight={600}>
                {t('glossary.appointment_detail')}
              </Box>
              {!isPayingSuccessPage && (
                <Box
                  pb={1.5}
                  justifyContent="space-between"
                  alignItems="center"
                  display="flex"
                  color="grey.900"
                >
                  <Box display="flex" alignItems="center">
                    <Box mr={1}> {statusMark(orderInfo.payStatus)}</Box>
                    {orderInfo?.payStatus === ORDER_STATUS.PAID && <Paid />}
                    {orderInfo?.payStatus === ORDER_STATUS.PENDING_PAYMENT && <PendingPayment />}

                    {orderInfo?.payStatus === ORDER_STATUS.REFUNDED && <Refund />}
                    {(orderInfo?.payStatus === ORDER_STATUS.REFUND_FAILED ||
                      orderInfo?.payStatus === ORDER_STATUS.APPROVAL_FAILED) && <FailRefund />}
                    {(orderInfo.payStatus === ORDER_STATUS.PENDING_REFUND ||
                      orderInfo.payStatus === ORDER_STATUS.APPROVAL_SUCCEED) && <Refunding />}
                  </Box>
                </Box>
              )}
            </Box>
            <Divider />
            <Box display="flex" my={matches ? 1 : 3} justifyContent="space-between">
              <Box className={classes.column} flexShrink="0">
                <Typography className={classes.heading}>{t('glossary.order_id')}</Typography>
              </Box>
              <Box>
                <Typography className={classes.secondaryHeading}>{orderInfo?.orderNumber}</Typography>
              </Box>
            </Box>
            <Box>
              <Box fontSize={matches ? 18 : 20} fontWeight={700}>
                {t(PACKAGE_INFO[orderInfo?.package].title)}
              </Box>
              <Box my={matches ? 1 : 2}>
                <ENumberFormat
                  color="secondary.main"
                  fontSize={!matches && 20}
                  value={Number(orderInfo?.price)}
                  currency={orderInfo?.currency}
                />
              </Box>
            </Box>
            <Box display="flex" alignItems="center" my={1} position="relative">
              <Box
                component="span"
                fontSize={matches ? 16 : 20}
                fontWeight={700}
                display="flex"
                alignItems="center"
              >
                <Box display="flex" alignItems="center" mr={18}>
                  <LocationOnOutlinedIcon
                    variant="outline"
                    style={{ fontSize: matches ? 24 : 20, marginRight: 4 }}
                  />
                  {orderInfo?.[tB('testCenterName')]}
                </Box>
                <Box flexShrink={0} position="absolute" right={2}>
                  <GoogleMap
                    lng={orderInfo?.lng}
                    lat={orderInfo?.lat}
                    name={orderInfo[tB('testCenterName')]}
                    address={addressFormat(
                      orderInfo[tB('testCenterAddress')],
                      t(translateRegion(orderInfo?.area)),
                    )}
                  >
                    <Box display="flex">
                      <MapOutlinedIcon style={{ color: '#24252d' }} />
                      <span
                        style={{
                          fontSize: 16,
                          lineHeight: 1.5,
                          textDecoration: 'underline',
                          color: '#24252d',
                          cursor: 'pointer',
                        }}
                      >
                        {t('glossary.map')}
                      </span>
                    </Box>
                  </GoogleMap>
                </Box>
              </Box>
            </Box>{' '}
            <Box fontSize={matches ? 14 : 16} ml={2.5} mb={2} color="#4B5563">
              {orderInfo?.[tB('testCenterAddress')]}
            </Box>
            <Divider />
            <Box
              display="flex"
              alignItems="center"
              my={matches ? 2 : 3}
              justifyContent="space-between"
              fontSize={matches ? 14 : 16}
            >
              <Box display="flex" alignItems="center" fontWeight={600}>
                <DateRangeOutlinedIcon variant="outline" style={{ marginRight: 4 }} />
                {t('common.booking_date')}
              </Box>
              <Box component="span" fontSize={matches ? 14 : 16}>
                {formatDate(new Date(orderInfo?.appointmentDate))}
              </Box>
            </Box>
            <Divider />
            <Box
              my={matches ? 2 : 3}
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              fontSize={matches ? 14 : 16}
            >
              <Box display="flex" alignItems="center" fontWeight={600}>
                <AccessTimeIcon variant="outline" style={{ marginRight: 4 }} />
                {t('glossary.appointment_time')}
              </Box>
              <Box fontSize={matches ? 14 : 16}> {orderInfo?.appointmentTime}</Box>
            </Box>
            <Divider />
            <Box
              display="flex"
              alignItems="center"
              my={matches ? 2 : 3}
              justifyContent="space-between"
              fontSize={matches ? 14 : 16}
            >
              <Box display="flex" alignItems="center" fontWeight={600}>
                <DoctorIcon variant="outline" style={{ marginRight: 4 }} />
                {t('glossary.doctor')}
              </Box>
              <Box component="span" fontSize={matches ? 14 : 16} fontWeight={700}>
                {orderInfo?.[tB('doctorName')] || ''}
              </Box>
            </Box>
            <Divider />
            {/* <Box display="flex" alignItems="center" my={2} justifyContent="space-between" pb={1}>
            <Box display="flex" alignItems="center" fontWeight={600}>
              <CallOutlinedIcon variant="outline" style={{ fontSize: 16, marginRight: 4 }} />
              {t('common.testcenter_phone')}
            </Box>
            <Box component="span" fontSize={14}>
              +{orderInfo?.testCenterPhone}
            </Box>
          </Box>
          <Divider /> */}
            <Box my={2}>
              {Number(orderInfo?.price - orderInfo?.payPrice) > 0 &&
                orderInfo?.payStatus !== ORDER_STATUS.PENDING_PAYMENT &&
                orderInfo?.payStatus !== ORDER_STATUS.CANCELLED && (
                  <Box className={classes.accordionDetails} mb={1}>
                    <Box className={classes.column} color="#4B5563">
                      <Typography>{t('common.promotion_price')}</Typography>
                    </Box>
                    <Box>
                      <Typography>
                        -
                        <ENumberFormat
                          value={Number(orderInfo?.price - orderInfo?.payPrice)}
                          currency={orderInfo?.currency}
                        />
                      </Typography>
                    </Box>
                  </Box>
                )}
              <Box className={classes.accordionDetails}>
                <Box className={classes.column} color="#111827">
                  <Typography className={classes.heading}>{t('common.add_summary')}</Typography>
                </Box>
                <Box>
                  <Typography className={classes.secondaryHeading}>
                    <ENumberFormat
                      value={Number(Number(orderInfo?.payPrice ? orderInfo?.payPrice : orderInfo?.price))}
                      currency={orderInfo?.currency}
                      color="#111827"
                    />
                  </Typography>
                </Box>
              </Box>
            </Box>
            <Divider />
            {orderInfo?.payPrice && (
              <Box>
                <Box className={classes.accordionDetails} my={1}>
                  <Box className={classes.column} color="#4B5563">
                    <Typography>{t('payMents.payMethods.0')}</Typography>
                  </Box>
                  <Box>{orderInfo?.payMode || (orderInfo?.payMethod ? 'Atome' : '')}</Box>
                </Box>
                <Box className={classes.accordionDetails} mb={2}>
                  <Box className={classes.column} color="#4B5563">
                    <Typography>{t('common.pay_date')}</Typography>
                  </Box>
                  <Box>{orderInfo?.payTime}</Box>
                </Box>
              </Box>
            )}
            <Divider />
            <Box fontSize={16} fontWeight={600} color="secondary.main" my={2}>
              {t('common.test_and_contact')}
            </Box>
            <Box pb={1}>
              <InfoItem
                label={t('form.name')}
                fontSize={matches ? 14 : 16}
                value={
                  <Box fontWeight="fontWeightBold" component="span">
                    {userInfo?.nameEn}
                  </Box>
                }
              />
              {/* <InfoItem
              label={t('form.gender')}
              value={userInfo?.gender === '0' ? t('form.male') : t('form.female')}
            /> */}
              <InfoItem
                fontSize={matches ? 14 : 16}
                label={t('form.id_number')}
                value={encryptId(userInfo?.identifyId, userInfo?.identifyType)}
              />
              <InfoItem label={t('form.birthday')} fontSize={matches ? 14 : 16} value={userInfo?.birthday} />
              <InfoItem
                fontSize={matches ? 14 : 16}
                label={t('form.mobile_phone')}
                value={formatDialingCode(userInfo?.dialingCode) + encryptPhone(userInfo?.phone)}
              />
              <InfoItem
                label={t('form.email')}
                fontSize={matches ? 14 : 16}
                value={encryptEmail(userInfo?.email)}
              />
            </Box>
            <Divider />
            <Box fontSize={16} fontWeight={600} color="secondary.main" my={2}>
              {t('tips.main_tips')}{' '}
            </Box>
            <Box pb={2}>
              {' '}
              {orderInfo?.package > 2 ? (
                <>
                  <InfoItem
                    NoJustify
                    value={
                      <>
                        <ItemDot />
                        {t('tips.appointment_tips_list.10')}
                      </>
                    }
                  />
                  <InfoItem
                    NoJustify
                    value={
                      <>
                        <ItemDot />
                        {t('tips.appointment_tips_list.3')}
                      </>
                    }
                  />
                  <InfoItem
                    NoJustify
                    value={
                      <>
                        <ItemDot />
                        {t('tips.appointment_tips_list.11')}
                      </>
                    }
                  />
                  <InfoItem
                    NoJustify
                    value={
                      <>
                        <ItemDot />
                        {t('tips.appointment_tips_list.12', { phone: SERVICE_PHONE_02 })}
                      </>
                    }
                  />
                  <InfoItem
                    NoJustify
                    value={
                      <>
                        <ItemDot />
                        {t('tips.appointment_tips_list.8', { phone: SERVICE_PHONE_02 })}
                      </>
                    }
                  />
                  <InfoItem
                    NoJustify
                    value={
                      <>
                        <ItemDot />
                        {t('tips.appointment_tips_list.9', { phone: SERVICE_PHONE_02 })}
                      </>
                    }
                  />{' '}
                  <InfoItem
                    NoJustify
                    value={
                      <>
                        <ItemDot />
                        {t('tips.appointment_tips_list.5', { phone: SERVICE_PHONE_02 })}
                      </>
                    }
                  />
                </>
              ) : (
                <>
                  <InfoItem
                    NoJustify
                    value={
                      <>
                        <ItemDot />
                        {t('tips.appointment_tips_list.7')}
                      </>
                    }
                  />
                  <InfoItem
                    NoJustify
                    value={
                      <>
                        <ItemDot />
                        {t('tips.appointment_tips_list.3')}
                      </>
                    }
                  />
                  <InfoItem
                    NoJustify
                    value={
                      <>
                        <ItemDot />
                        {t('tips.appointment_tips_list.8')}
                      </>
                    }
                  />
                  <InfoItem
                    NoJustify
                    value={
                      <>
                        <ItemDot />
                        {t('tips.appointment_tips_list.9', { phone: SERVICE_PHONE_02 })}
                      </>
                    }
                  />
                  <InfoItem
                    NoJustify
                    value={
                      <>
                        <ItemDot />
                        {t('tips.appointment_tips_list.5', { phone: SERVICE_PHONE_02 })}
                      </>
                    }
                  />
                </>
              )}
            </Box>
          </Box>
        </InfoWrapper>

        {/* <InfoWrapper title={step < 1 ? t('glossary.personal_info') : t('glossary.booker_info')}></InfoWrapper> */}
        {/* <InfoWrapper title={t('tips.main_tips')}></InfoWrapper> */}
      </Box>
      {/* {userInfo && step && (
        <Box mx={2} mb={1.5} fontSize="body2.fontSize" color="grey.500">
          {t('tips.pay_success', {
            phone: userInfo.phone
              ? formatDialingCode(userInfo?.dialingCode) + encryptPhone(userInfo?.phone)
              : '',
            email: userInfo.email ? encryptEmail(userInfo?.email) : '',
          })}
        </Box>
      )} */}
    </>
  ) : (
    <Loading title={t('tips.empty_data', { field: '$t(glossary.order_info)' })} status={orderInfoStatus} />
  )
}

export default OrderInfo
